import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

/**
 * Agrega `Authorization: Bearer <token>` a cada petición de la API.
 *
 * El token se lee en CADA petición (vía el getter de AuthService, que consulta
 * localStorage). Antes se capturaba una sola vez en el constructor: como el
 * interceptor nace con la primera petición —la del login, cuando todavía no hay
 * token— se quedaba vacío y la app tenía que hacer `window.location.reload()`
 * tras autenticarse para que naciera otra vez ya con sesión. Ese reload era el
 * "se traba, vuelve a salir el login y luego carga" que veían los usuarios.
 *
 * Tampoco limpia localStorage ni navega desde el constructor: de la sesión se
 * encargan AuthGuard (rutas) y ErrorInterceptor (401).
 */
@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {

    constructor(private authenticationService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.headers.has('skip')) {
            request = request.clone({
                headers: request.headers.delete('skip')
            });
            return next.handle(request);
        }

        if (request.url.includes('/login')) {
            return next.handle(request);
        }

        const token = this.authenticationService.token;

        // Respeta un Authorization puesto a mano (p. ej. verifyAccount manda el
        // token del correo, no el de la sesión).
        if (token && !request.headers.has('Authorization')) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
        }

        return next.handle(request);
    }

}
